import styled from '@emotion/styled'
import { BREAKPOINTS } from '@classy/campaign-page-blocks'

export interface StickyDrawerProps {
  isVisible?: boolean
}

export const StickyDrawer = styled.div<StickyDrawerProps>`
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  height: 100px;
  padding-block: 16px;
  padding-inline: 48px;
  justify-content: center;
  align-items: center;
  background-color: var(--classy-color__neutral--100);
  box-shadow: 0 0 20px 0 rgba(35, 35, 35, 0.1);

  /* Animate in/out from the bottom */
  transform: translateY(${(p) => (p.isVisible ? '0%' : '100%')});
  opacity: ${(p) => (p.isVisible ? 1 : 0)};
  pointer-events: ${(p) => (p.isVisible ? 'auto' : 'none')};
  transition:
    transform 420ms cubic-bezier(0.22, 1, 0.36, 1),
    opacity 300ms ease-out;
  will-change: transform;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: none;
  }
`

export const StickyCtaButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-block: 12px;
  padding-inline: 24px;
  font-family: var(--theme-font__font-family--general);
  font-size: var(--classy-font__paragraph-md--font-size);
  line-height: var(--classy-font__paragraph-lg-bold--line-height);
  font-weight: var(--classy-font__paragraph-lg-bold--font-weight);
  color: var(--classy-color__neutral--100);
  background-color: #000;
  border-radius: var(--classy-border__radius-lg);
  border: unset;
  overflow: hidden;
  cursor: pointer;
`
